import styled, { css, keyframes } from 'styled-components';
import React, { useEffect, useRef, useState } from 'react';
import { debounce } from '@cko/utils';
// StickyHeader appear and disappear animations
const up = (stickyWrapperHeight) => {
    return keyframes `
    from {
      top: 0;
    }
    to {
      top: -${stickyWrapperHeight}px;
    }
  `;
};
const down = (stickyWrapperHeight) => {
    return keyframes `
    from {
      top: -${stickyWrapperHeight}px;
    }
    to {
      top: 0;
    }
  `;
};
// Styles for StickyHeader
const StickyHeaderWrapper = styled.div `
  background-color: white;
  box-shadow: var(--control-e-shoe);
  clip-path: inset(-24px 0px);
  opacity: 0;
  position: absolute;
  z-index: 1;

  &.sticky,
  &.notSticky {
    position: fixed;
  }

  &.sticky {
    animation: ${({ stickyWrapperHeight }) => stickyWrapperHeight
    ? css `
            ${down(stickyWrapperHeight)} 0.3s ease-in-out
          `
    : 'none'};
    opacity: 1;
    top: 0;
  }

  &.notSticky {
    animation: ${({ stickyWrapperHeight }) => stickyWrapperHeight
    ? css `
            ${up(stickyWrapperHeight)} 0.3s ease-in-out
          `
    : 'none'};
    top: ${({ stickyWrapperHeight }) => (stickyWrapperHeight ? css `-${stickyWrapperHeight}px` : 0)};
    opacity: 0;
    transition: opacity 1s linear;
  }
`;
/**
 * @deprecated - This component is due to be deleted Please remove from your mfe.
 */
export const StickyHeader = (props) => {
    const { target, children, width, paddingVertical, paddingHorizontal, background } = props;
    const [isSticky, setSticky] = useState(false);
    const stickyWrapper = useRef(null);
    // Set StickyHeader width and height
    const stickyWrapperHeight = stickyWrapper.current
        ? stickyWrapper.current.clientHeight
        : 0;
    let stickyHeaderWidth = 'auto';
    if (width) {
        stickyHeaderWidth = width;
    }
    // Set the trigger distance from top
    const [hasTopDistance, setHasTopDistance] = useState(false);
    const [topDistance, setTopDistance] = useState(0);
    if (target) {
        if (!hasTopDistance) {
            setTopDistance(typeof target === 'object'
                ? target.getBoundingClientRect().top + window.pageYOffset
                : target);
            setHasTopDistance(true);
        }
    }
    useEffect(() => {
        const onScroll = () => {
            calculateStickiness();
        };
        // Calculate if the header should be sticky or not
        const calculateStickiness = () => {
            if (target) {
                const stickyTrigger = (typeof target === 'object' ? target.clientHeight : 0) + topDistance;
                const stickyTriggered = window.pageYOffset >= stickyTrigger;
                setSticky(stickyTriggered);
            }
        };
        // allow to recalculate trigger point from top
        const handleResize = debounce(() => {
            setHasTopDistance(false);
        }, 100);
        // Set StickyHeader to sticky if the target prop is set to 0
        const checkIfTop = () => {
            if (target === 0) {
                setSticky(true);
            }
        };
        checkIfTop();
        if (target && stickyWrapper) {
            setTimeout(() => {
                calculateStickiness();
            }, 500);
            window.addEventListener('scroll', onScroll);
            window.addEventListener('resize', handleResize);
        }
        return () => {
            window.removeEventListener('scroll', onScroll);
            window.removeEventListener('resize', handleResize);
        };
    });
    return (React.createElement(StickyHeaderWrapper, { className: isSticky ? 'sticky' : 'notSticky', ref: stickyWrapper, style: {
            background: background || 'var(--base-bg-primary)',
            marginLeft: paddingHorizontal ? -paddingHorizontal : 0,
            padding: `${paddingVertical || 0}px ${paddingHorizontal || 0}px`,
            width: stickyHeaderWidth,
        }, stickyWrapperHeight: stickyWrapperHeight }, children));
};
